module.exports = __webpack_public_path__ + "static/media/offers.f6430202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offers.png
// module id = 88
// module chunks = 0